import { Facade } from "./Common";
export class GrooveShuffleImpl extends Facade {
    static wrap(context, box) {
        return context.facade(box, () => new GrooveShuffleImpl(context, box));
    }
    constructor(context, box) {
        super(context, box);
        this.bind({ label: box.label, amount: box.amount, duration: box.duration });
    }
}
